export enum LoaderType {
  Determinate = 'Determinate',
  Indeterminate = 'Indeterminate'
}
